export default "__VITE_ASSET__BSSw8yGa__"